<template>
    <v-card>
        <v-card-title>{{ t('Ecografías') }}</v-card-title>
        <v-card-text>
            {{ t('Ecografías') }}
        </v-card-text>
    </v-card>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>